import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Resolution886ReportService } from '@/infra/services/resolution-886-report';
import { QUERY_KEYS } from '@/utils/query-keys';

type PreventiveMeasureResult = {
	preventive_measure_key: string;
	preventive_measure_result: string;
	preventive_measure_description?: string | null;
};

interface CreateUpdatePreventiveMeasureParams {
	organization_id: string;
	company_id: string;
	report_id: string;
	review_id: string;
	preventive_measures_results: PreventiveMeasureResult[];
}

const Service = Resolution886ReportService.getInstance();

export function useCreateUpdatePreventiveMeasure() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (params: CreateUpdatePreventiveMeasureParams) =>
			Service.createUpdatePreventiveMeasure(params),
		onSuccess: () => {
			queryClient.invalidateQueries([QUERY_KEYS.CREATE_UPDATE_PREVENTIVE_MEASURE]);
		},
		onError: () => {
			message.error(I18n.get('Error creating preventive measure'));
		}
	});
}
